import { useMemo } from 'react';

import { getTextColor } from '~/theme';

export const useModuleColors = (backgroundColor?: string) => {
	const textColor = useMemo(() => getTextColor(backgroundColor), [backgroundColor]);

	return { backgroundColor, textColor };
};
